import React from "react";
import { Box, Text, HStack, VStack, Radio } from "@chakra-ui/react";

interface KYDRadioCardProps {
  title: string;
  description: string;
  value: string;
  isSelected: boolean;
  isDisabled?: boolean;
  onChange: (value: string) => void;
  name: string;
  children?: React.ReactNode;
}

const KYDRadioCard: React.FC<KYDRadioCardProps> = ({
  title,
  description,
  value,
  isSelected,
  isDisabled = false,
  onChange,
  name,
  children,
}) => {
  return (
    <Box
      w="full"
      p={4}
      border="1px solid"
      borderColor={isSelected ? "blue.500" : "gray.200"}
      borderRadius="md"
      backgroundColor="white"
      cursor={isDisabled ? "not-allowed" : "pointer"}
      opacity={isDisabled ? 0.5 : 1}
      _hover={
        !isDisabled ? { borderColor: isSelected ? "blue.500" : "gray.300" } : {}
      }
      onClick={!isDisabled ? () => onChange(value) : undefined}
    >
      <VStack align="flex-start" spacing={3}>
        <HStack justify="space-between" align="flex-start" spacing={4} w="full">
          <VStack align="flex-start" flex={1} spacing={2}>
            <Text
              fontWeight="bold"
              fontSize="md"
              color="gray.800"
              lineHeight="1.2"
            >
              {title}
            </Text>
            <Text fontSize="sm" color="gray.600" lineHeight="1.4">
              {description}
            </Text>
          </VStack>
          <Radio
            value={value}
            name={name}
            isChecked={isSelected}
            isDisabled={isDisabled}
            onChange={() => onChange(value)}
            onClick={(e) => e.stopPropagation()}
            sx={{
              ".chakra-radio__control": {
                borderColor: "gray.300",
                borderWidth: "1px",
                _hover: {
                  borderColor: "gray.400",
                },
                _checked: {
                  bg: "blue.500",
                  borderColor: "blue.500",
                },
              },
            }}
          />
        </HStack>
        {isSelected && children && (
          <Box w="full" pt={2}>
            {children}
          </Box>
        )}
      </VStack>
    </Box>
  );
};

export default KYDRadioCard;
